import { z } from '@harvestiq/zod';
import { dbFaqUpdateSchema } from './db-faq';
import { faqSchema } from './faq';
import { getFaqByIdParamsSchema } from './get-faq-by-id-schema';

export const updateFaqRequestParamsSchema = getFaqByIdParamsSchema;

export const updateFaqRequestBodySchema = dbFaqUpdateSchema.pick({
  question: true,
  answer: true,
  isActive: true,
});

export type UpdateFaqRequestParams = z.infer<
  typeof updateFaqRequestParamsSchema
>;
export type UpdateFaqRequestBody = z.infer<typeof updateFaqRequestBodySchema>;

export const updateFaqResponseSchema = z.object({
  success: z.boolean(),
  faq: faqSchema.nullable(),
});

export type UpdateFaqResponse = z.infer<typeof updateFaqResponseSchema>;
